var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDarFilterPurpleColor = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 18,
  height: 16,
  viewBox: "0 0 18 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M17.0151 1.36955C16.9189 1.14729 16.7595 0.95822 16.5567 0.825844C16.3539 0.693468 16.1167 0.623632 15.8745 0.62502H2.12449C1.88256 0.625497 1.64597 0.696169 1.44342 0.828463C1.24086 0.960757 1.08105 1.14899 0.983372 1.37032C0.885691 1.59165 0.854338 1.83658 0.893116 2.07538C0.931894 2.31418 1.03914 2.53659 1.20183 2.71565L1.20808 2.72268L6.49949 8.37268V14.375C6.49944 14.6013 6.56078 14.8233 6.67699 15.0174C6.79319 15.2115 6.95989 15.3704 7.15933 15.4772C7.35876 15.584 7.58343 15.6347 7.80941 15.6239C8.03538 15.613 8.25417 15.5411 8.44246 15.4156L10.9425 13.7485C11.1138 13.6343 11.2544 13.4796 11.3515 13.298C11.4487 13.1165 11.4995 12.9137 11.4995 12.7078V8.37268L16.7917 2.72268L16.7979 2.71565C16.9623 2.53741 17.0706 2.3147 17.1092 2.07531C17.1479 1.83592 17.1151 1.59045 17.0151 1.36955ZM10.4198 7.70158C10.3117 7.81621 10.2509 7.96745 10.2495 8.12502V12.7078L7.74949 14.375V8.12502C7.74954 7.96631 7.68921 7.81353 7.58074 7.69768L2.12449 1.87502H15.8745L10.4198 7.70158Z",
  fill: "currentColor"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgDarFilterPurpleColor);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/dar_filter_purple_color.8135bec65bc4adbb93d6f390de8008bf.svg";